// Background tabs pause requestAnimationFrame and throttle timers, so any load
// that spends time hidden produces inflated shell timings.
let hidden = false;
let tracking = false;

function hasHiddenVisibilityEntry() {
  // 'visibility-state' entries (Chromium 115+) cover the time before this
  // script ran; unsupported browsers return an empty list.
  return performance
    .getEntriesByType('visibility-state')
    .some((entry) => entry.name === 'hidden');
}

function onVisibilityChange() {
  if (document.visibilityState !== 'hidden') return;
  hidden = true;
  document.removeEventListener('visibilitychange', onVisibilityChange);
}

export function startPageVisibilityTracking() {
  if (tracking) return;
  tracking = true;

  if (document.visibilityState === 'hidden' || hasHiddenVisibilityEntry()) {
    hidden = true;
    return;
  }

  document.addEventListener('visibilitychange', onVisibilityChange);
}

export function wasPageHidden() {
  if (!hidden) {
    hidden =
      document.visibilityState === 'hidden' || hasHiddenVisibilityEntry();
  }
  return hidden;
}
